import { useSelector } from "react-redux";

import EbookPage from "./EbookPage";

// 리더스북(지인에듀, 2026-10-17). 지금은 전자책(ebook) 섹션 하나만 낸다.
// 활동 문항을 온라인으로 푸는 섹션은 다음 단계에서 여기에 붙인다.
const ReadersBookPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section?.type === "ebook") {
    return <EbookPage setCurrentStep={setCurrentStep} isPreview={isPreview} isReview={isReview} />;
  }
  return null;
};

export default ReadersBookPage;
